import baseProperty from './_baseProperty.js';

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

export default asciiSize;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_asciiSize.js
// module id = 2201
// module chunks = 67